module.exports = __webpack_public_path__ + "static/img/img_g.1dde4a7f.png";